/* @flow */
import cx from 'classnames';
import * as React from 'react';

import './styles/HovercardBody.scss';

/**
 * ## Content area for use within [HoverCard](/internal/components/HoverCard).
 *
 *
 * ```example
 * <HoverLayerTrigger
 *   defaultLayerShown
 *   layer={
 *     <Hovercard>
 *       <HovercardBody>
 *         HovercardBody
 *       </HovercardBody>
 *     </Hovercard>
 *   }>
 *   <Button>Hover</Button>
 * </HoverLayerTrigger>
 * ```
 */

class HovercardBody extends React.Component<$FlowFixMeProps> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <div {...props} className={cx('HovercardBody', className)}>
        {children}
      </div>
    );
  }
}

export default HovercardBody;
